import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useContent, useWa } from "@/lib/content";
import { WhatsIcon } from "./Primitives";

export const WhatsAppFab = () => {
  const { TEXTS: T } = useContent();
  const waLink = useWa();
  const [show, setShow] = useState(false);
  const [bubble, setBubble] = useState(false);

  useEffect(() => {
    const a = setTimeout(() => setShow(true), 1800);
    const b = setTimeout(() => setBubble(true), 7000);
    const c = setTimeout(() => setBubble(false), 19000);
    return () => {
      clearTimeout(a);
      clearTimeout(b);
      clearTimeout(c);
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ opacity: 0, scale: 0.6, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3 md:bottom-8 md:right-8">
          <AnimatePresence>
            {bubble && (
              <motion.div
                data-testid="whatsapp-bubble"
                initial={{ opacity: 0, y: 10, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 10 }}
                className="relative w-[270px] rounded-2xl rounded-br-sm border border-gold/20 bg-cream p-4 pr-9 font-sans text-sm text-espresso shadow-2xl"
              >
                <button data-testid="whatsapp-bubble-close" onClick={() => setBubble(false)} className="absolute right-2 top-2 p-1 text-espresso/60 hover:text-espresso" aria-label="Cerrar">
                  <X size={14} />
                </button>
                {String(T.btn_bubble || "").split(/\*(.+?)\*/g).map((p, i) => (i % 2 ? <strong key={i}>{p}</strong> : p))}
              </motion.div>
            )}
          </AnimatePresence>
          <a
            data-testid="whatsapp-floating-btn"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Escríbenos por WhatsApp"
            className="group relative flex h-16 w-16 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_15px_40px_-10px_rgba(37,211,102,0.6)] transition-transform duration-300 hover:scale-110"
          >
            <span className="absolute inset-0 animate-ping-slow rounded-full bg-[#25D366]/50" />
            <WhatsIcon className="relative h-8 w-8" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
